import { Button } from 'components/Button';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from 'slices/loginSlice';

import { SidebarUserInfo } from 'types/user';

interface Props {
  userInfo: SidebarUserInfo;
}

const UserInfo = ({ userInfo }: Props) => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const onClickLogoutButton = () => {
    dispatch(logout());
    nav('/login');
  };

  return (
    <>
      <Link to="/my-page">
        <div className="flex h-12 w-full flex-row gap-2 px-2 py-2">
        {userInfo.profilePic ? (
          <img src={userInfo.profilePic} alt="Profile" />
        ) : (
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-black">
            <span className="text-white">{userInfo.email[0]}</span>
          </div>
        )}
        <div className="center ml-1 flex h-full flex-col items-center justify-center">
          <span className="text-body2 font-regular text-text-primary">{userInfo.email}</span>
        </div>
        </div>
      </Link>
      <Button
        className="h-8 w-full items-center justify-center"
        text="Logout"
        type="secondary"
        onClick={onClickLogoutButton}
      />
    </>
  );
};

export default UserInfo;
